<template>
  <div class="grid-column jc-b">
    <div>
      <div>
        <div class="sac__font-20 n90 bold">
          Services Offered
        </div>
        <div class="sub-header pt-1">
          At least one service must be selected
        </div>
      </div>
      <div>
        <div v-for="(service, idx) in serviceCategoryList" :key="idx" class="mb-2">
          <SACCheckbox
            :label="service.category"
            :field="service.category"
            :checked="serviceOffered.includes(service.category)"
            :change="() => changeList(service.category)"
            :disable="serviceOffered.length === 1 && serviceOffered.includes(service.category)"
          />
        </div>
      </div>
    </div>
    <div class="grid-column">
      <div class="grid-row">
        <MyTechPreview />
        <div>
          <div class="pc-preview-title text-center">
            My Tech
          </div>
          <div class="sac__font-14 n60 text-center">
            Member App
          </div>
        </div>
      </div>
      <div class="grid-row">
        <ServiceRequestServicesPreview
          :serviceOffered="serviceOffered"
        />
        <div>
          <div class="pc-preview-title text-center">
            Service Categories
          </div>
          <div class="sac__font-14 n60 text-center">
            Member App
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import MyTechPreview from '@shared/components/partnerSettings/serviceRequest/MyTechPreview.vue';
import ServiceRequestServicesPreview from '@shared/components/partnerSettings/serviceRequest/ServiceRequestServicesPreview.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';

export default {
  name: 'ServiceRequestServicesSection',
  components: {
    MyTechPreview,
    ServiceRequestServicesPreview,
    SACCheckbox,
  },
  mixins: [partnerSettingsMixin],
  props: {
    handleRequest: String,
    changeList: Function,
    errorObj: Object,
    primaryContact: Object,
    serviceCategoryList: Array,
    serviceOffered: Array,
  },
};
</script>

<style lang="scss" scoped>
.ac-row-container {
  display: flex;
  justify-content: space-between;
}

.filter-options {
  display: grid;
  //gap: 8px;
  margin-top: 10px;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
  cursor: pointer;
  max-height: 250px;
}

.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}

.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
  margin-bottom: 24px;
}

.ac-upload-wrapper {
  width: 49%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
}

.blue-underline {
  text-decoration: underline;
  color: $NBLUE100;
  font-weight: 600;
  cursor: pointer;
}

.ac-centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ac-preview-container {
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .ac-logo-preview-container {
    border-radius: 9px;
    width: 183px;
    height: 183px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    img {
      width: 100%;
    }
  }

  .ac-edit-image-btn {
    background-color: $NBLUE100;
    color: $WHITE;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    padding: 5px;
    margin-right: 16px;

    img {
      width: 100%;
      object-fit: contain;
    }
  }

  .ac-change-image-btn {
    background-color: $NBLUE100;
    height: 36px;
    color: $WHITE;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: 4px;
    padding: 0 12px;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
